import { Header } from "@/components/landing/Header";
import { TopBar } from "@/components/landing/TopBar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { WhyJoin } from "@/components/landing/WhyJoin";
import { Urgency } from "@/components/landing/Urgency";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { ThankYouModal } from "@/components/landing/ThankYouModal";
import { LenisProvider } from "@/components/landing/LenisProvider";

function App() {
  return (
    <LenisProvider>
      <div className="min-h-screen bg-[#08090b] text-white" data-testid="mik-first-access-page">
        <div className="grain-overlay" aria-hidden="true" />
        <TopBar />
        <Header />
        <main>
          <Hero />
          <Marquee text="Teacher's Day Reveal — MIK Ecosystem" />
          <WhyJoin />
          <Urgency />
          <FinalCTA />
        </main>
        <ThankYouModal />
      </div>
    </LenisProvider>
  );
}

export default App;
